/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ad7f31f2 (Tue Mar  3 17:44:55 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Applicable direction values for order by clauses during pagination.
 * @export
 * @enum {string}
 */
export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export function OrderByDirectionFromJSON(json: any): OrderByDirection {
  return OrderByDirectionFromJSONTyped(json, false)
}

export function OrderByDirectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OrderByDirection {
  return json as OrderByDirection
}

export function OrderByDirectionToJSON(value?: OrderByDirection | null): any {
  return value as any
}
